import { render, staticRenderFns } from "./EditSpecification.vue?vue&type=template&id=8546ed66&scoped=true&"
import script from "./EditSpecification.vue?vue&type=script&lang=js&"
export * from "./EditSpecification.vue?vue&type=script&lang=js&"
import style0 from "./EditSpecification.vue?vue&type=style&index=0&id=8546ed66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8546ed66",
  null
  
)

export default component.exports